import {
  ICancelShiftDropRequestDTO,
  ICancelShiftPickupRequestDTO,
  ICreateShiftDropRequestDTO,
  ICreateShiftPickupRequestDTO,
  IShiftDropDTO,
  IShiftPickupDTO,
  IUpdateShiftDropRequestDTO,
  IUpdateShiftPickupRequestDTO,
} from 'src/api/dtos';
import ESSRepository from 'src/api/repositories/ess/ess.repository';
import api from 'src/api/rtk/rtk-api';
import { IQueryResult } from 'src/api/types';

export default class ShiftSwapRepository extends ESSRepository {
  private static readonly baseRoute = '/shiftswap';
  private static readonly apiURL = ShiftSwapRepository.setBaseUrl(this.baseURL, this.baseRoute);

  public static endpoints = api.injectEndpoints({
    overrideExisting: true,
    endpoints: (build) => ({
      createShiftDrop: build.mutation<IShiftDropDTO, ICreateShiftDropRequestDTO>({
        query: (data) => {
          return { url: `${this.apiURL}/drop`, method: 'post', data };
        },
        transformResponse: (response: IQueryResult<IShiftDropDTO>) => response.item,
        invalidatesTags: (_, error) => (error ? [] : ['Calendar']),
      }),
      cancelShiftDrop: build.mutation<void, ICancelShiftDropRequestDTO>({
        query: (data) => {
          return { url: `${this.apiURL}/drop/${data.shiftDropId}/cancel`, method: 'patch' };
        },
        invalidatesTags: (_, error) => (error ? [] : ['Calendar']),
      }),
      updateShiftDrop: build.mutation<IShiftDropDTO, IUpdateShiftDropRequestDTO>({
        query: (data) => {
          const { shiftDropId } = data;
          return { url: `${this.apiURL}/drop/${shiftDropId}`, method: 'patch', data };
        },
        transformResponse: (response: IQueryResult<IShiftDropDTO>) => response.item,
        invalidatesTags: (_, error) => (error ? [] : ['Calendar']),
      }),
      createShiftPickup: build.mutation<IShiftPickupDTO, ICreateShiftPickupRequestDTO>({
        query: (data) => {
          return { url: `${this.apiURL}/pickup`, method: 'post', data };
        },
        transformResponse: (response: IQueryResult<IShiftPickupDTO>) => response.item,
        invalidatesTags: (_, error) => (error ? [] : ['Calendar']),
      }),
      cancelShiftPickup: build.mutation<void, ICancelShiftPickupRequestDTO>({
        query: (data) => {
          return { url: `${this.apiURL}/pickup/${data.shiftPickupId}/cancel`, method: 'patch' };
        },
        invalidatesTags: (_, error) => (error ? [] : ['Calendar']),
      }),
      updateShiftPickup: build.mutation<IShiftPickupDTO, IUpdateShiftPickupRequestDTO>({
        query: (data) => {
          const { shiftPickupId } = data;
          return { url: `${this.apiURL}/pickup/${shiftPickupId}`, method: 'patch', data };
        },
        transformResponse: (response: IQueryResult<IShiftPickupDTO>) => response.item,
        invalidatesTags: (_, error) => (error ? [] : ['Calendar']),
      }),
    }),
  });
}
